<template>
  <b-dropdown v-if='showMenu && menuIsNotEmpty'>
    <template #button-content>
      <i class="fa fa-ellipsis-v"></i>
    </template>
    <give-access-button
      v-if='visibleCloseButton'
      :visitor='visitor'
      @change-access="$emit('change-visitor-access', visitor)"
    />
    <issue-pass-button
      v-if='visibleVisitorIssuePassButton'
      title='Выдать пропуск'
      :is-issued='visitor.personal.isIssued'
      @issue-pass="$emit('issue-pass', visitor)"
    />
    <issue-pass-button
      v-if='visibleVisitorIssuePassPeriodButton'
      title='Выдать пропуска'
      :is-issued='visitor.personal.isIssued'
      @issue-pass="$emit('issue-pass', visitor)"
    />
    <print-pass-button
      v-if='visibleVisitorPrintPassButton'
      title='Распечатать пропуск'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
    <print-pass-button
      v-if="visibleVisitorPrintPassPeriodButton"
      title='Распечатать пропуска'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
    <print-pass-button
      v-if='visibleVisitorPrintPassPermanentAsOneButton'
      title='Выдать разовый пропуск'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
    <print-pass-button
      v-if='visibleVisitorPrintPassPermanentButton'
      title='Выдать постоянный пропуска'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
    <!-- <send-to-solvo-button
      v-if='visibleVisitorSendToSolvoButton'
      :application-id='application.id'
      :personal-id='visitor.personal.id'
    />
    <send-to-scud-button
      :in-scud='inScud'
      :application-id='application.id'
      :personal-id='visitor.personal.id'
      :visitor='visitor'
      :transport-id='transport.id'
    /> -->
  </b-dropdown>
</template>

<script>
import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames';
import GiveAccessButton from './buttons/GiveAccessButton.vue';
import IssuePassButton from './buttons/IssuePassButton.vue';
import PrintPassButton from './buttons/PrintPassButton.vue';
import SendToSolvoButton from './buttons/SendToSolvoButton.vue';
import SendToScudButton from './buttons/SendToScudButton.vue';
export default {
  components: {
    GiveAccessButton,
    IssuePassButton,
    PrintPassButton,
    SendToSolvoButton,
    SendToScudButton
  },

  props: {
    visitor: {
      type: Object
    },

    cfgMenuVisitor: {
      type: Object
    }
  },

  computed: {
    menuIsNotEmpty() {
      return this.visibleCloseButton || this.visibleVisitorIssuePassButton || this.visibleVisitorIssuePassPeriodButton || this.visibleVisitorPrintPassButton ||
        this.visibleVisitorPrintPassPeriodButton || this.visibleVisitorPrintPassPermanentAsOneButton || this.visibleVisitorPrintPassPermanentButton
    },

    isGivePassPeriod() {
      return !!this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD]
    },

    printPermanentAsOne() {
      return Boolean(this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE])
    },

    visibleCloseButton() {
      return Boolean(this.user && this.cfgMenuVisitor.give_access_visitor)
    },

    visibleVisitorIssuePassButton() {
      return Boolean(
        this.visitor.access === 0 && (
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] ||
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] ||
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT]) &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD]
      )
    },

    showMenu() {
      return Array.isArray(this.cfgMenuVisitor) === false || this.visibleCloseButton
    },

    visibleVisitorIssuePassPeriodButton() {
      return this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS]
    },

    visibleVisitorPrintPassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] &&
        this.visitor.personal.isIssued
      )
    },

    visibleVisitorPrintPassPeriodButton() {
      return this.visitor.access === 0 &&
          this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
          !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
          !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] &&
          !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
          this.visitor.personal.isIssued
    },

    visibleVisitorPrintPassPermanentAsOneButton() {
      return this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.visitor.personal.isIssued
    },

    visibleVisitorPrintPassPermanentButton() {
      return this.visitor.access === 0 &&
        this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.visitor.personal.isIssued
    },

    visibleVisitorSendToSolvoButton() {
      return Boolean(this.visitor.access === 0 && this.cfgMenuVisitor[ConfigMenuNames.SEND_TO_SOLVO])
    }
  }
}
</script>
